<template>
    <span>
        <a
            class="action icon-export"
            title="Download"
            :data-test-id="`row-${row.id}-action-download`"
            @click.prevent="download()"
        />
    </span>
</template>

<script>
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'

export default {
    name: 'DiagnosticLogActions',

    mixins: [canToast, needsOrganizationSlug],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    methods: {
        download() {
            this.$http
                .get(`${this.organizationSlug}/diagnostic-logs/${this.row.id}/download-url`)
                .then(({ data }) => {
                    window.location.href = data.url
                })
                .catch((error) => {
                    const { status } = error.response
                    let message = 'Could not download: '

                    switch (status) {
                        case 403:
                            message += 'You do not have permission'
                            break
                        case 404:
                            message += 'File does not exist'
                            break
                        default:
                            message = 'Oops! Something went wrong'
                            break
                    }

                    this.toast(message, 'error')
                })
        },
    },
}
</script>
